
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { getCurrentUser } from "@/utils/index";
import { getDashboardECPWelcomeData } from "@/api/dashboard";
import ECP_EDP_DashboardNavigator from "@/components/cards/ECP_EDP_DashboardNavigator.vue";
import SeqNoticeCard from "@/components/dashboard/sequence/SeqNoticeCard.vue";

import { getOVICoverageInfo } from "@/api/ovi_api";

export default defineComponent({
  name: "reminderspage",
  components: {
    ECP_EDP_DashboardNavigator,
    SeqNoticeCard,
  },
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      user: {},
      ecp_welcome_data: {},
      r2meLink: "",
      r2meLinkLabel: "",
      oviShopLink: "",
      oviShopLinkLabel: "",
      ecverseLink: "",
      ecverseLinkLabel: "",
      isLoading: true,
      pt: "",
      allowClose: true,
      renewBannerFlag: false,
      unilevelMaintenancePromptMessage: "",
      unilevelMaintenancePromptMessage1: "",
      unilevelMaintenancePromptMessage2: "",
      isShowQualifiedMessage: false,
      isShowPMAWarning: false,
      pmaReminderButtons: [
        { label: "Complete your maintenance NOW", href: "#/estore", color: "primary" },
      ],
      copiedKey: "",
      shareOpenKey: "",
      shareNetworks: [
        { network: "facebook", name: "Facebook", icon: "fab fa-facebook-f", color: "#1877f2" },
        { network: "viber", name: "Viber", icon: "fab fa-viber", color: "#59267c" },
        { network: "whatsapp", name: "WhatsApp", icon: "fab fa-whatsapp", color: "#25d366" },
        { network: "telegram", name: "Telegram", icon: "fab fa-telegram-plane", color: "#0088cc" },
        { network: "twitter", name: "Twitter", icon: "fab fa-twitter", color: "#1da1f2" },
        { network: "messenger", name: "Messenger", icon: "fab fa-facebook-messenger", color: "#0084ff" },
        { network: "email", name: "Email", icon: "far fa-envelope", color: "#333333" },
        { network: "sms", name: "SMS", icon: "far fa-comment-dots", color: "#333333" },
      ],
    };
  },
  mounted() {
    this.getPT();
    this.user = getCurrentUser();
    this.getDashboardECPWelcomeData();
    this.getOviCoverageInfo();
  },
  methods: {
    shareTitle(label: string) {
      return `Check out my ${String(label || "").trim()} link`;
    },
    shareDescription(label: string) {
      return `Shop using my ${String(label || "").trim()} referral link.`;
    },
    toggleShare(key: string) {
      this.shareOpenKey = this.shareOpenKey === key ? "" : key;
    },
    async copyLink(url: string, key: string) {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const input = document.createElement("input");
          input.value = url;
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        this.copiedKey = key;
        setTimeout(() => {
          if (this.copiedKey === key) {
            this.copiedKey = "";
          }
        }, 2000);
      } catch (e) {
        console.error(e);
      }
    },
    async getDashboardECPWelcomeData() {
      this.isLoading = true;
      const response = await getDashboardECPWelcomeData();

      this.ecp_welcome_data = response.data;

      this.unilevelMaintenancePromptMessage = response.data.unilevelMaintenancePromptMessage || "";
      this.unilevelMaintenancePromptMessage1 = this.unilevelMaintenancePromptMessage.split(
        "complete your maintenance NOW"
      )[0];
      this.unilevelMaintenancePromptMessage2 =
        this.unilevelMaintenancePromptMessage.split("complete your maintenance NOW")[1] || "";

      if (this.unilevelMaintenancePromptMessage) {
        if (
          this.unilevelMaintenancePromptMessage.includes("Qualified for next month") ||
          this.unilevelMaintenancePromptMessage.includes("FREE MAINTENANCE")
        ) {
          this.isShowQualifiedMessage = true;
        } else {
          this.isShowQualifiedMessage = false;
        }

        this.isShowPMAWarning =
          this.unilevelMaintenancePromptMessage.includes("To continue") &&
          !!response.data.is10DaysLeftForPMA;
      } else {
        this.isShowQualifiedMessage = false;
        this.isShowPMAWarning = false;
      }

      if (this.pt == "ovi" || this.pt == "ecp") {
        this.r2meLink =
          "https://shop.empoweredconsumerism.com/?ecpid=" + response.data.firstUsidInPlacement;
        this.r2meLinkLabel = "EC R2ME";
        this.oviShopLink =
          "https://shop.orbixvictus.com/?ecpid=" + response.data.firstUsidInPlacement;
        this.oviShopLinkLabel = "OVI Shop";
        this.ecverseLink =
          "https://ecverse.empoweredconsumerism.com/?ecpid=" + response.data.firstUsidInPlacement;
        this.ecverseLinkLabel = "ECVerse ";
      }

      this.isLoading = false;
    },
    async getPT() {
      this.pt = String(localStorage.getItem("pt"));
    },
    async showRetroPMAPage() {
      this.$router.push("/retropma");
    },

    async getOviCoverageInfo() {
      const response = await getOVICoverageInfo();
      if (response.data !== undefined && response.data.activeCoverage != undefined) {
        let activeCoverage = response.data.activeCoverage;
        for (let i = 0; i < activeCoverage.length; i++) {
          if (
            activeCoverage[i].coveragests === "EXPIRING" ||
            activeCoverage[i].coveragests === "EXPIRED"
          ) {
            this.renewBannerFlag = true;
            break;
          }
        }
      }
    },
  },
  setup() {},
});
